/** Ce e comun intre lista „Clienții mei" si fisa clientului. */

export const lei = (n: number | null | undefined, zecimale = 0) =>
  n == null
    ? '—'
    : `${n.toLocaleString('ro-RO', { minimumFractionDigits: zecimale, maximumFractionDigits: zecimale })} lei`

export const LUNI_SCURT = [
  'ian.',
  'feb.',
  'mar.',
  'apr.',
  'mai',
  'iun.',
  'iul.',
  'aug.',
  'sept.',
  'oct.',
  'nov.',
  'dec.',
]

/** „14 oct." (cu anul doar cand nu e cel curent). */
export function dataScurta(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso)
  const an = d.getUTCFullYear() !== new Date().getUTCFullYear() ? ` ${d.getUTCFullYear()}` : ''
  return `${d.getUTCDate()} ${LUNI_SCURT[d.getUTCMonth()]}${an}`
}

/** Zile de la o data pana azi. */
export function zileDeLa(iso: string | null | undefined): number | null {
  if (!iso) return null
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86_400_000)
}

export const eroare = (e: unknown, implicit = 'Nu s-a putut salva.') =>
  (e as { response?: { data?: { error?: { message?: string } } } })?.response?.data?.error
    ?.message ?? implicit

export interface RandClient {
  id: number
  nume: string
  agent: string | null
  grup: string | null
  oras: string | null
  puncte: number
  ultimaComanda: string | null
  /** Trecut de pragul de comanda (regula pe server, `faraComanda.service`); altfel null. */
  pauza: {
    ultimaComanda: string
    zile: number
    prag: number
    ritm: number | null
    sursa: 'crm' | 'erp' | 'factura' | null
    stare: 'de_facut' | 'amanat' | 'nu_urmari' | 'pierdut'
    amanatPana: string | null
    motiv: string | null
    ultimaNota: { data: string; nota: string; de: string } | null
  } | null
  sellIn: number
  target: number
  pctTarget: number | null
  deIncasat: number
  restant: number | null
  zileIntarziere: number | null
  scadente7: { count: number; suma: number }
  sellout: { pct: number; lipsa: number; ultimaLuna: string | null } | null
}

// Aceeasi regula ca pe server (`lista.service.ts`): conteaza suma scadenta.
export const esteRestant = (c: Pick<RandClient, 'restant'>) => (c.restant ?? 0) > 0.5
